import { render, staticRenderFns } from "./html-text-widget.vue?vue&type=template&id=1c034a5d&scoped=true"
import script from "./html-text-widget.vue?vue&type=script&lang=js"
export * from "./html-text-widget.vue?vue&type=script&lang=js"
import style0 from "./html-text-widget.vue?vue&type=style&index=0&id=1c034a5d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c034a5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c034a5d')) {
      api.createRecord('1c034a5d', component.options)
    } else {
      api.reload('1c034a5d', component.options)
    }
    module.hot.accept("./html-text-widget.vue?vue&type=template&id=1c034a5d&scoped=true", function () {
      api.rerender('1c034a5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/html-text-widget.vue"
export default component.exports